export default "__VITE_ASSET__tcDMDMHp__"